<template>
  <title-description
    id="campaign-title"
    class="mb-2"
    :disable-title="disableFields"
    :disable-description="disableFields"
    :title.sync="campaign.title"
    :description.sync="campaign.description"
    :status="campaign.status"
    :title-error="validations.campaign.title && validations.campaign.title.$error"
    :title-error-message="errorTitle"
    :description-error="validations.campaign.description && validations.campaign.description.$error"
    :description-error-message="errorDescription"
    new-style
  >
    <hr class="mb-4" />
    <div class="app-section">
      <div>
        <h1>Aplicativo</h1>
        <label for="campaign-app-title">Título exibido no app</label>
        <v-text-field
          id="campaign-app-title"
          v-model="campaign.appTitle"
          outlined
          :error="validations.campaign.appTitle && validations.campaign.appTitle.$error"
          :error-messages="errorAppTitle"
          :disabled="disableFields"
          counter
          maxlength="30"
          placeholder="Título exibido no app"
        />
      </div>
    </div>
  </title-description>
</template>

<script>
import TitleDescription from '@/modules/campanhas/views/components/edit/TitleDescription.vue'
export default {
  name: 'CouponDiscountTitle',
  components: { TitleDescription },
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    disableFields() {
      return ['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    errorTitle() {
      if (!this.validations.campaign.title) return ''
      if (this.validations.campaign.title.$error) {
        if (!this.validations.campaign.title.required) return 'Dê um nome para esta campanha.'
        else if (!this.validations.campaign.title.minLength) return 'O título possui menos de 2 caracteres.'
        else if (!this.validations.campaign.title.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorDescription() {
      if (!this.validations.campaign.description) return ''
      if (this.validations.campaign.description.$error) {
        if (!this.validations.campaign.description.required) return 'Informe detalhes para melhor identificação da campanha.'
        else if (!this.validations.campaign.description.minLength) return 'A descrição possui menos de 2 caracteres.'
        else if (!this.validations.campaign.description.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorAppTitle() {
      if (!this.validations.campaign.appTitle) return ''
      if (this.validations.campaign.appTitle.$error) {
        if (!this.validations.campaign.appTitle.required) return 'Dê um título para ser exibido no app.'
        else if (!this.validations.campaign.appTitle.minLength) return 'O título no app possui menos de 2 caracteres.'
        else if (!this.validations.campaign.appTitle.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid $cinza-l60;
}

.app-section {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  gap: 20px;

  h1 {
    font-weight: 700;
    color: $cinza-d10;
    font-size: 18px;
  }

  label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: $cinza-d10;
    margin-bottom: 8px;
  }
}
</style>
